import { AbstractFormDefinition } from '../abstract-form-definition';
import {
  Type,
  InjectionToken
} from '@angular/core';
import { FORM_INSTANCE_METADATA_KEY } from './metadata-keys';
import { AbstractFormComponent2 } from '../abstract-form.component-2';
import { addToMetadata } from '@digitaix/helpers';

export interface FormInstanceDefinition<
  Form,
  Definition extends AbstractFormDefinition<Form, any>
> {
  formId: string;
  collectionPath?: string;
  editComponent?: Type<AbstractFormComponent2<Form, any, Definition>>;
  title?: string;
  load?: string[];
  token?: InjectionToken<Definition>;
}

/**
 * @deprecated
 */
export function FormInstance<
  Form,
  Definition extends AbstractFormDefinition<Form, any>
>(definition: FormInstanceDefinition<Form, Definition>) {
  return function(target: any) {
    addToMetadata(FORM_INSTANCE_METADATA_KEY, definition, target);
  };
}
